/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PaymentType {
  Money = 'MONEY',
  Points = 'POINTS'
}
